import * as React from 'react';

import { DisableOpenNewTabToast } from '@/utils/toasts';

import { useDevices } from './useDevices';

export const usePopupBlockedMessaging = () => {
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  const { isIOS } = useDevices();

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return React.useCallback(() => {
    if (isIOS) {
      timeoutRef.current = setTimeout(DisableOpenNewTabToast, 2000);
    }
  }, [isIOS]);
};
